import React from "react";
import { Cell, Row } from "react-table";
import { BuildingFacilityTagModel, BuildingFacilityTagRequest } from "src/api/building/commonfacility-types";
import { BaseButton } from "src/components";
import TagChip from "src/components/TagChip";

const FacilityTagsColumns = [
  {
    Header: "순서",
    accessor: "",
    width: 100,
    Cell: ({
      row,
      rows,
      tableHelpers,
    }: {
      row: Row<BuildingFacilityTagModel>;
      rows: Row<BuildingFacilityTagModel>[];
      tableHelpers: { handleEditFacilityTag: (request: BuildingFacilityTagRequest) => Promise<void> };
    }) => {
      const { handleEditFacilityTag } = tableHelpers || {};

      const handleOrderChange = (direction: -1 | 1) => {
        const currentItem = row.original; // 클릭한 현재 필드
        const targetItem = rows[row.index + direction].original; //현재 필드 기준으로 이동할 target 필드

        const updatedCurrentItem = {
          tagId: String(currentItem.id),
          name: currentItem.name,
          priority: targetItem.priority, // 현재 필드의 순서 번호 대상 필드의 순서 번호 전달
        };

        handleEditFacilityTag(updatedCurrentItem);
      };

      return (
        <div className="flex-center " style={{ height: 30 }}>
          <BaseButton //
            title=""
            className={`base-btn ic-chevron-up mr2 cursor-pointer color-white pa0 h30 size-small`}
            disabled={row.index === 0}
            onClick={() => handleOrderChange(-1)}
          />
          <BaseButton //
            title=""
            className={`base-btn ic-chevron-down  cursor-pointer color-white pa0 h30`}
            disabled={row.index === rows.length - 1}
            onClick={() => handleOrderChange(1)}
          />
        </div>
      );
    },
  },
  {
    Header: "id",
    accessor: "id",
    width: 60,
  },
  {
    Header: "태그명",
    accessor: "name",
    width: 404,
    Cell: ({ row }: Cell<BuildingFacilityTagModel>) => {
      return <TagChip tag={row.original} />;
    },
  },

  {
    Header: "수정",
    accessor: "",
    width: 80,
    Cell: ({
      row,
      tableHelpers,
    }: {
      row: Row<BuildingFacilityTagModel>;
      tableHelpers: {
        handleOpenTagFormModal: (tagDetail?: BuildingFacilityTagModel) => void;
      };
    }) => (
      <BaseButton
        className="color-white size-small"
        title="수정"
        onClick={() => {
          const { handleOpenTagFormModal } = tableHelpers || {};
          handleOpenTagFormModal(row.original);
        }}
      />
    ),
  },
  {
    Header: "삭제",
    accessor: "",
    width: 50,
    Cell: ({
      row,
      tableHelpers,
    }: {
      row: Row<BuildingFacilityTagModel>;
      tableHelpers: { handleDeleteFacilityTag: (tagId: string) => Promise<void> };
    }) => {
      return (
        <button
          className="base-trash-btn color-bg-gray h40"
          onClick={() => {
            const tagId = row.original.id;
            const { handleDeleteFacilityTag } = tableHelpers || {};
            console.log("hi");
            handleDeleteFacilityTag(String(tagId));
          }}
        />
      );
    },
  },
];

export default FacilityTagsColumns;
